import { useEffect, useState } from "react"
import { getTargets, getTargetsbyTenant } from "./request"
import { useAppSelector } from "../../../../../redux/hooks"

type x={
    id:any,
    name:any
}

function SelectTarget(props:any){

    {/*Aqui se colocan todas las constantes a utilizar*/}
    const [targets,setTargets]=useState<x[]>([])
    const [targetSelect,setTargetSelect]=useState('')
    const tenant= useAppSelector(state =>state.TenantSlice.id)
    const Id = useAppSelector(state => state.SuscriptionSlice.id)
    {/************************************************/}

    useEffect(()=>{

        if(Id!==0 && tenant===0 ){
            getTargets().then(response=>{
                setTargets(response.data)
            })
        }
        else if(tenant!==0 && Id!==0 ){
            getTargetsbyTenant(tenant).then(response=>{
                setTargets(response.data)
            })
        }
        
    },[Id])

    useEffect(()=>{
            props.setTargetEnviar(targetSelect)
    },[targetSelect])
    
    return(
        <>
            <label className="form-label f-bold fs-p text-marino form-label" htmlFor="target">Target</label>
            <select className='form-select border-marino f-parrafo text-center w-200px h-40px' id='target' onChange={(e)=>setTargetSelect(e.target.value)}>
                <option value="">All</option>
                {
                    targets?.map((t,i)=>(
                        <option key={i} value={t.id}>{t.name}</option>
                    ))

                }
            </select>
        </>
    )
}

export {SelectTarget}